import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconInfoCircle16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8.75 7v5h-1.5V7zM8.75 5.5V4h-1.5v1.5z" }), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m0 1.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11",
			clipRule: "evenodd"
		})]
	})
});
const ForwardRef = forwardRef(SvgIconInfoCircle16);
export default ForwardRef;
